/*App Base Methods*/
window.app = window.app || {};

/*QueryString*/
window.app.queryString = (function () {
    var queryString = {};

    queryString.get = function (name, searchString) {
        searchString = searchString || location.search;
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)", "i"),
            results = regex.exec(searchString);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    };
    return queryString;
})();

/*
	NR error event.
*/
window.app.NRNoticeError = function (e) {
	!(e instanceof Error) && (e = new Error(e));
	window.NREUM && _.isFunction(window.NREUM.noticeError) && window.NREUM.noticeError(e);
};

/*
    API NR logged helper.
*/
window.app.APINRLogged = function (methodName, opts) {
	return window.api[methodName](opts).then(function (data) {
		return data;
	}, function () {
		window.app.NRNoticeError(methodName + ' API method failed');
	});
};

/*
    Needed because it's very easy way to get API instance instead of js attributes in master pages magic.
*/
window.app.onLoad = function (cb) {
	var listen = window.addEventListener || window.attachEvent,
		detach = window.removeEventListener || window.detachEvent,
		event = window.addEventListener && 'load' || 'onload';

	var handler = function() {
		detach(event, handler, false);
		cb();
	};

	listen(event, handler);
};

/*
	DC marketing tracking.
*/
window.app.marketingXhr = (function ($, app) {
	var $def = new $.Deferred();

	app.onLoad(function () {
		(function (api) {

			if (!app) {
				$def.resolve();
				app.NRNoticeError('Marketing Event is NOT working, because of no API instance');
				return;
			}

			/*
				(['a', 'b', 'c'], cb) => [[a, cb(a)], [b, cb(b)], [c, cb(c)]]
				If cb('a') will return false then will no 'a' param in the result.
			*/
			var _mapParams = function (params, cb) {
				return _.filter(_.zip(params, _.map(params, cb)), _.last);
			};

			// [[a, cb(a)], [b, cb(b)], [c, cb(c)]] => 'a=cb(a)&b=cb(b)&c=cb(c)'
			var _paramsToQueryString = function (params) {
				return _.invoke(params, 'join', '=').join('&');
			};

			/*
				Get ref domain.
				If referrer === host (without 'm' and 'www' prefixes) then return null.
			*/
			var _getRefDomain = function () {
				var refDomain = document.referrer && document.referrer.match(/:\/\/(.[^/]+)/)[1],
					deletePrefixRegexp = new RegExp(/^(m||www)\./i);

				if (refDomain && refDomain.replace(deletePrefixRegexp, '') === document.location.host.replace(deletePrefixRegexp, '')) {
					return null;
				} else {
					return refDomain;
				}
			};

			/*
				Build marketing data:
					If baseParams are present in query string or value of param fallbackQueryString then
					check for optParams (and add values if it present). Also it adds referrer domain to the data
					if referrer is present.
			*/
			var _buildMarketingData = function (baseParams, optParams, fallbackQueryString, refDomain, refParamName) {
				var queryParamGetter = function (name) {
					return app.queryString.get(name)
						|| app.queryString.get(name, decodeURIComponent(app.queryString.get(fallbackQueryString)));
				};

				var data = _mapParams(baseParams, queryParamGetter);

				data = data.length && data.concat(_mapParams(optParams, queryParamGetter));
				data = data.length && refDomain && data.concat([[refParamName, refDomain]]) || data;

				return data;
			};

			// Opts.
			var opts = {
				baseParams: ['referredBy', 'ui', 'sc', 'c', 'ca'],
				optParams: ['saleID', 'productID', 'image'],
				fallbackQueryString: 'ReturnUrl',
				refDomain: _getRefDomain(),
				refParamName: 'referrer'
			};
			var data = _buildMarketingData(opts.baseParams, opts.optParams, opts.fallbackQueryString, opts.refDomain, opts.refParamName);

			// Track.
			if (data.length) {
				api.setMarketingData(_paramsToQueryString(data), { hideErrors: true })
					.always($def.resolve);
			} else {
				$def.resolve();
			}

			// Instance of API will be provided by some scripts NOT from OzSale.Scripts.
		})(window.api);
	});

	return $def.promise();
})(jQuery, window.app);

window.app.enteredSale = (function (marketingXhr) {

	return function (data, callback) {
		if (!api) {
			app.NRNoticeError('Entered Sale Event is NOT working, because of no API instance');
			return;
		}

		marketingXhr.done(function () {
			api.enteredSale(data, { hideErrors: true }).done(callback);
		});
	}

})(window.app.marketingXhr);

window.app.enteredSaleItem = (function (marketingXhr) {

	return function (data, callback) {
		if (!api) {
			app.NRNoticeError('Entered Sale Event is NOT working, because of no API instance');
			return;
		}

		marketingXhr.done(function () {
			api.enteredSaleItem(data, { hideErrors: true }).done(callback);
		});
	}

})(window.app.marketingXhr);

/*
    User utils function.
*/
window.app.user = window.app.user || {};

window.app.user.isLoggedIn = function() {
	// Cookie 'us' will be 'unl' after logout. Meaning of 'b' cookie is not available, but this is
	// copy-paste from other old parts of the code.
	if (window.app.cookie.get('us') === null || window.app.cookie.get('us') === 'unl' || window.app.cookie.get('b') === '0') {
		return false;
	}
	return true;
};

/*
    Validation
*/
window.app.validation = window.app.validation || {};

window.app.validation.validateEmail = function (input) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test($.trim($(/*this*/input).val()));
    //return /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.(([a-zA-Z]{2,3})|(aero|coop|info|museum|name))$/.test($.trim($(this).val()));
};

/*
    JS utils.
*/
window.app.jsUtils = window.app.jsUtils || {};

window.app.jsUtils.createObjectWithProto = (function() {
	var ObjectWithProto = function () { };

	return function(proto) {
		ObjectWithProto.prototype = proto;
		var o = new ObjectWithProto();
		ObjectWithProto.prototype = null;
		return o;
	};
})();

/*
 * Settings utils.
 */
window.app.settingsUtils = window.app.settingsUtils || {};

window.app.settingsUtils.getSiteDataGeneralSetting = function (settingName) {
	return $('[id$="siteData"]').data('general')[settingName];
};

window.app.settingsUtils.getSiteDataGeneralSection = function () {
	var d = $('[id$="siteData"]').data('general');
	return d;
};

(function ($) {

    var _updateCookieExp = function (settings) {
        app.cookie.set(settings.LandingSiteCookieName, new Date(), { expires: settings.LandingSiteCookieTimeSpan, expires_time_mode: app.cookie.expires_time_mode.minute });
    };

    $(function () {
		var settings = window.app.settingsUtils.getSiteDataGeneralSection();

        if (!settings.LandingSiteCookieTimeSpan) return;

        if (settings.LandingSiteCookieName && document.cookie.indexOf(settings.LandingSiteCookieName + '=') < 0) {
            api.sendLandingSiteEvent({
                pageUrl: location.href
            }).done(function () {
                _updateCookieExp(settings);
            });
        } else {
            _updateCookieExp(settings);
        }
        
    });

})(jQuery);